import { environment } from '@environments/environment';

export const GET_ACTIVE_POPINS_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_popins ?? '',
  body: {
    size: 100,
    track_total_hits: false,
    _source: ['text', 'title', 'urls'],
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            exists: {
              field: 'urls',
            },
          },
          {
            exists: {
              field: 'start_date',
            },
          },
          {
            exists: {
              field: 'end_date',
            },
          },
          {
            range: {
              start_date: {
                lte: 'now',
              },
            },
          },
          {
            range: {
              end_date: {
                gt: 'now',
              },
            },
          },
        ],
      },
    },
  },
});
